import { join } from 'light-component';
import { InputNumber } from 'antd';
import { Box } from '../../../box';
import { service } from '../service';
import styles from '../style.module.less';
import { Highlighter } from '../../component';
import type { ReactElement } from 'react';
import type { ShotEyesAmountProps } from './types';

export function ShotEyesAmountInputMode(props: ShotEyesAmountProps): ReactElement {
  return (
    <Box className={styles.inputBox} style={{ marginLeft: service.getIndent(props.path, 0.7) }}>
      <Box className={styles.subject}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
          require={props.validator === 'required'}
        />
      </Box>
      <Box className={join(styles.action, styles.input)}>
        <InputNumber
          type='number'
          style={{ width: '100%' }}
          value={props.value}
          readOnly={props.readonly === true}
          placeholder={props.textPlaceholder}
          onChange={value => props.onPropsChange?.({ value })}
        />
      </Box>
    </Box>
  );
}
